module.exports = __webpack_public_path__ + "banner-cachorro-e-humano.acc2754407e273d29007.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/assets/images/banner-cachorro-e-humano.jpg
// module id = ../../../../../src/assets/images/banner-cachorro-e-humano.jpg
// module chunks = main